import { Maybe } from '@iss/libs/graphql';
import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'wo-details-box',
  templateUrl: './details-box.component.html',
  styleUrls: [ './details-box.component.scss' ],
  standalone: true,
  imports: [
    NgIf,
  ],
})
export class DetailsBoxComponent {
  @Input() public primary: Maybe<unknown>;
  @Input() public secondary: Maybe<unknown>;

  public get primaryDefined(): boolean {
    return this.primary != null;
  }

  public get secondaryDefined(): boolean {
    return this.secondary != null;
  }
}
